import { useState, useEffect, useContext } from "react";
import api from "../services/api";
import { AuthContext } from "../context/Auth/AuthContext";

const useSystemBlock = () => {
  const [isBlocked, setIsBlocked] = useState(false);
  const { user, isAuth, loading: authLoading } = useContext(AuthContext);

  useEffect(() => {
    const checkBlockStatus = async () => {
      // Se não estiver autenticado ou ainda carregando, não bloqueia
      if (!isAuth || authLoading) {
        setIsBlocked(false);
        return;
      }

      // Se não tiver user carregado, não bloqueia
      if (!user || !user.id) {
        setIsBlocked(false);
        return;
      }

      // Se for o usuário 1, nunca bloqueia
      if (user.id == 1) {
        setIsBlocked(false);
        return;
      }

      try {
        const { data } = await api.get("/settings/systemBlock");
        setIsBlocked(data.value === "enabled");
      } catch (err) {
        console.error("Erro ao verificar status de bloqueio:", err);
        setIsBlocked(false);
      }
    };

    checkBlockStatus();
  }, [user, isAuth, authLoading]);

  return { isBlocked };
};

export default useSystemBlock;
